import { render, staticRenderFns } from "./AssetAccountabilityDetailsView.vue?vue&type=template&id=64e7d66a&scoped=true"
import script from "./AssetAccountabilityDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetAccountabilityDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AssetAccountabilityDetailsView.vue?vue&type=style&index=0&id=64e7d66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e7d66a",
  null
  
)

export default component.exports